import type { FaireProductEntity } from "../../entity_types/product";

export const p_nepeacpue3: FaireProductEntity = {
  token: "p_nepeacpue3",
  type: "product",
  name: "Brazilian Clear Quartz Tower",
  brandToken: "b_2qbyxhh869",
  brandName: "Prettygoods",
  imageUrl:
    "https://cdn.faire.com/fastly/361ae7a129ed824251deaf5861acf100cfafca0e77332e84da7fc701e25d498b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a6b84d6ddbe336c063437c462458172823e71a0dfec5a065eafbc1c7ee67fe0f.jpeg",
  ],
  priceDollars: 22.17,
  description:
    "You will receive the item pictured here. All of our crystals and minerals are authentic and high quality. ",
  tags: [],
  msrpDollars: 44.34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:02.920Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
